import React from 'react';
import { Check, Download } from 'lucide-react';
interface PriceBoxProps {
  onAddToCart?: () => void;
}
export function PriceBox({
  onAddToCart
}: PriceBoxProps) {
  return <section id="price-box" className="py-16 md:py-20 px-4 bg-[#0f0f0f]" data-id="element-103">
      <div className="max-w-lg mx-auto" data-id="element-104">
        <div className="bg-[#1a1a1a] rounded-2xl border border-[#C9A84C] p-8 md:p-12 relative shadow-[0_0_50px_rgba(201,168,76,0.1)]" data-id="element-105">
          {/* Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#C9A84C] text-black font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide" data-id="element-106">
            PDF Ebook
          </div>

          {/* Discount badge */}
          <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wide shadow-lg" data-id="element-107">
            76% OFF
          </div>

          <h2 className="text-3xl font-serif text-center text-white mb-6 mt-4" data-id="element-108">
            Acceso inmediato hoy
          </h2>

          {/* Launch offer banner */}
          <div className="flex items-center justify-center gap-2 mb-4 mt-2" data-id="element-109">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shrink-0" data-id="element-110"></span>
            <p className="text-xs uppercase tracking-widest text-red-400 font-semibold" data-id="element-111">
              Oferta de lanzamiento activa por tiempo limitado
            </p>
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shrink-0" data-id="element-112"></span>
          </div>

          <div className="space-y-4 mb-8" data-id="element-113">
            {['El Azúcar Silencioso (Ebook PDF)', 'Checklist + Registro de 14 días', 'Protocolo de Rescate de 15 minutos'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-114">
                <div className="bg-[#C9A84C]/20 p-1 rounded-full mt-0.5" data-id="element-115">
                  <Check className="w-3 h-3 text-[#C9A84C]" data-id="element-116" />
                </div>
                <span className="text-gray-300" data-id="element-117">{item}</span>
              </div>)}
          </div>

          <div className="text-center mb-6" data-id="element-118">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-119">
              <span className="text-3xl text-[#555] line-through font-medium" data-id="element-120">
                $27
              </span>
              <span className="bg-red-600/20 text-red-400 text-xs font-bold px-2 py-0.5 rounded" data-id="element-121">
                76% OFF
              </span>
            </div>
            <div className="text-7xl font-bold text-[#C9A84C] mb-1" data-id="element-122">$6.39</div>
            <div className="text-sm text-[#666] uppercase tracking-wider" data-id="element-123">
              USD
            </div>
          </div>

          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full mb-4" onClick={() => onAddToCart?.()} data-id="element-124">
            <button className="w-full bg-[#C9A84C] hover:bg-[#b09240] text-black font-bold text-lg py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2" data-id="element-125">
              <Download className="w-5 h-5" data-id="element-126" />
              Comprar ahora — Descarga inmediata
            </button>
          </a>

          <p className="text-center text-xs text-[#555]" data-id="element-127">
            Producto digital. No requiere envío.
          </p>
        </div>
      </div>
    </section>;
}